class ActivateCodeElement extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleClick.bind(this));
  }

  async handleClick() {
    const code = this.getAttribute("discount-code");
    if (code) {
      await this.applyDiscountCode(code);
    }
  }

  /**
   * @param {string} code
   */
  async applyDiscountCode(code) {
    const response = await fetch(
      `${window.Shopify.routes.root + "cart/update.js"}`,
      {
        body: JSON.stringify({ discount: code }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const cartContent = await response.json();
    if (cartContent.discount_codes) {
      this.classList.add("success");
    }
  }
}

if (!customElements.get("activate-code")) {
  customElements.define("activate-code", ActivateCodeElement);
}
